/**
 * @fileoverview Label - Public API
 */
export { Label, type LabelProps } from "./label";
